export default __webpack_public_path__ + "static/media/thumbOptions.ea0adc23.svg";